/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Allinvestmentstatuses3Inputs */

const en_coinvestments_filters_allinvestmentstatuses3 = /** @type {(inputs: Coinvestments_Filters_Allinvestmentstatuses3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All investment statuses`)
};

/**
* | output |
* | --- |
* | "All investment statuses" |
*
* @param {Coinvestments_Filters_Allinvestmentstatuses3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_allinvestmentstatuses3 = /** @type {((inputs?: Coinvestments_Filters_Allinvestmentstatuses3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Allinvestmentstatuses3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_allinvestmentstatuses3(inputs)
});
export { coinvestments_filters_allinvestmentstatuses3 as "coInvestments_filters_allInvestmentStatuses" }